(ns common.schema.entities.risk.core
  "Common entity-type definition of the risk. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the risk documents with the calculated fields."
  (:require
   [common.schema.entities.risk.schema :as risk]
   [common.schema.entities.risk.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/risk
   :schema                       risk/schema
   :name                         {:en "Risk"}
   :plural                       {:en "Risks"}
   :icon                         :fa-exclamation-triangle
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
